<section class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-6">
        <h1>Edit Onboarding</h1>
      </div>
      <div class="col-sm-6">
        <ol class="breadcrumb float-sm-right">
          <li class="breadcrumb-item"><a href="#">Home</a></li>
          <li class="breadcrumb-item">
            <a href="/onboarding">Onboarding</a>
          </li>
          <li class="breadcrumb-item active">
            {{
              currentOnboarding?.organisation?.tag ||
                currentOnboarding?.organisation?._id
            }}
          </li>
        </ol>
      </div>
    </div>
  </div>
  <!-- /.container-fluid -->
</section>

<app-onboarding-form
  [onboarding]="currentOnboarding"
  [loading]="loading"
  (submitForm)="updateOnboarding($event)"
></app-onboarding-form>

<div class="footer"></div>
